import { Gem, Moon, Clock, CreditCard } from "lucide-react";
import useReveal from "../hooks/useReveal";

const TEXTURE =
  "https://static.prod-images.emergentagent.com/jobs/b84d0196-ce96-4816-ad90-5ea3362a6c1d/images/0f73173b48735294d1876347a3d704752e4ea5b6b960a92ee0e00e8442ff5970.png";

const tiers = [
  {
    label: "Base Ride",
    sub: "Pickup + first 10 minutes",
    price: "$25",
  },
  { label: "10 – 25 Minutes", sub: "Standard short ride", price: "$45" },
  { label: "25 – 45 Minutes", sub: "Cross-town comfort", price: "$65" },
  { label: "45 – 60 Minutes", sub: "Extended journey", price: "$85" },
];

export const Pricing = () => {
  const r1 = useReveal();
  const r2 = useReveal();
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="relative py-24 sm:py-32 px-5 sm:px-8 overflow-hidden"
    >
      {/* Faded texture background */}
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <img
          src={TEXTURE}
          alt=""
          aria-hidden
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-[#05030A] via-[#05030A]/80 to-[#05030A] pointer-events-none" />

      <div className="relative max-w-5xl mx-auto">
        <div ref={r1} className="reveal text-center mb-16">
          <Gem
            className="w-6 h-6 text-[#D4AF37] mx-auto mb-4"
            strokeWidth={1.4}
          />
          <span className="font-sans text-xs uppercase tracking-[0.32em] text-[#D4AF37]">
            Flat-Rate Pricing
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white mt-5 leading-tight">
            Honest, elegant, <span className="italic gold-text">no surprises.</span>
          </h2>
        </div>

        {/* Pricing menu */}
        <div
          ref={r2}
          data-testid="pricing-menu"
          className="reveal bg-[#0D0814]/80 backdrop-blur-md border border-white/5 shadow-[0_8px_32px_rgba(0,0,0,0.5)]"
        >
          <div className="p-8 sm:p-12">
            <ul>
              {tiers.map((t, i) => (
                <li
                  key={t.label}
                  data-testid={`pricing-tier-${i}`}
                  className={`flex items-end justify-between gap-6 py-5 ${
                    i !== tiers.length - 1
                      ? "border-b border-white/10"
                      : ""
                  }`}
                >
                  <div>
                    <p className="font-serif text-xl sm:text-2xl text-white">
                      {t.label}
                    </p>
                    <p className="font-sans text-sm text-[#A89FBB] font-light mt-1">
                      {t.sub}
                    </p>
                  </div>
                  <div className="flex items-end gap-3">
                    <span className="hidden sm:block flex-1 border-b border-dashed border-white/15 mb-2 min-w-[40px]" />
                    <span className="font-serif text-2xl sm:text-3xl gold-text font-semibold tracking-tight">
                      {t.price}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Add-ons row */}
          <div className="grid grid-cols-1 md:grid-cols-3 border-t border-white/10">
            <div className="p-7 sm:p-8 border-b md:border-b-0 md:border-r border-white/10">
              <Moon
                className="w-5 h-5 text-[#D4AF37] mb-3"
                strokeWidth={1.5}
              />
              <p className="font-sans text-[11px] uppercase tracking-[0.28em] text-[#A89FBB]">
                Late Night Premium
              </p>
              <p className="font-serif text-lg text-white mt-2 leading-snug">
                After 9PM <span className="gold-text">+$10</span>
                <br />
                After Midnight{" "}
                <span className="gold-text">+$20</span>
              </p>
            </div>
            <div className="p-7 sm:p-8 border-b md:border-b-0 md:border-r border-white/10">
              <Clock
                className="w-5 h-5 text-[#D4AF37] mb-3"
                strokeWidth={1.5}
              />
              <p className="font-sans text-[11px] uppercase tracking-[0.28em] text-[#A89FBB]">
                Wait Time
              </p>
              <p className="font-serif text-lg text-white mt-2 leading-snug">
                5-minute grace period
                <br />
                Then <span className="gold-text">$10</span> per 10 mins
              </p>
            </div>
            <div className="p-7 sm:p-8">
              <CreditCard
                className="w-5 h-5 text-[#D4AF37] mb-3"
                strokeWidth={1.5}
              />
              <p className="font-sans text-[11px] uppercase tracking-[0.28em] text-[#A89FBB]">
                Payment Methods
              </p>
              <p className="font-serif text-lg text-white mt-2 leading-snug">
                Cash · Cash App
                <br />
                Venmo · Zelle
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
